import React, { Component } from 'react'
import { Route, withRouter } from 'react-router-dom'

import { filterRecords } from './filter'
import { matchWithRecordId, selectedRecord } from './helpers'
import { ListRedirect } from './redirect'
import ListWrapper from './views'
import Detail from './views/detail'

export class ListContainer extends Component {
  constructor(props) {
    super(props)
    this.filterTermChanged = this.filterTermChanged.bind(this)

    this.state = {
      filterTerm: props.filterTerm || '',
      recordsStale: true,
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.base_url !== this.props.base_url) {
      this.setState({ recordsStale: true })
    }

    if (!this.props.loading && prevProps.loading) {
      this.setState({ recordsStale: false })
    }
  }

  render() {
    const { filterTerm, recordsStale } = this.state
    const {
      records = [],
      loading = true,
      base_url,
      listComponent,
      detailComponent,
      emptyComponent,
      className,
      idField,
      filterDisabled = false,
      filterOn,
      location,
    } = this.props

    const match = matchWithRecordId({ location, base_url })
    const primaryKey = record => record[idField] || record.id
    const recordsTotal = recordsStale ? 0 : records.length
    const currentRecordID = match.params.record_id
    const recordsFiltered = filterRecords(records, filterTerm, filterOn)

    return (
      <ListRedirect
        loading={loading}
        recordsStale={recordsStale}
        base_url={base_url}
        primaryKey={primaryKey}
        records={recordsFiltered}
        recordsTotal={recordsTotal}
        currentRecordID={currentRecordID}>
        <ListWrapper
          key={base_url}
          filterDisabled={filterDisabled}
          filterTerm={filterTerm}
          filterOnChange={this.filterTermChanged}
          records={recordsFiltered}
          recordsTotal={records.length}
          className={className}
          loading={loading}
          currentRecordID={currentRecordID}
          base_url={base_url}
          component={listComponent}
          emptyComponent={emptyComponent}
          primaryKey={record => record[idField] || record.id}>
          <Route
            path={base_url + '/:record_id'}
            render={({ match }) => (
              <Detail
                record={selectedRecord(records, idField, match.params.record_id)}
                loading={loading}
                base_url={base_url}
                component={detailComponent}
              />
            )}
          />
        </ListWrapper>
      </ListRedirect>
    )
  }

  filterTermChanged(newTerm) {
    this.setState({
      filterTerm: newTerm,
    })
  }
}

export default withRouter(ListContainer)



// WEBPACK FOOTER //
// ./src/ui/list/container.js